// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2-4X0","buttons":"PendingPaymentAlert_buttons__xPODg"};